import styled from 'styled-components';
import { ClearFix } from '../../../ui-components/utils.styles';
import { device } from '../../../ui-components/breakpoints';
import { Heading1 } from '../../../ui-components/typography/Heading.styles';

export const Container = styled.article`
    max-width: 26em;
    margin: 30px auto 50px;
    ${ClearFix}

    @media ${device.GteSmall} {
        max-width: 44em;
        margin-bottom: 90px;
    }

    @media ${device.GteMedium} {
        max-width: 30em;
        margin-top: 60px;
    }

    @media ${device.GteLarge} {
        max-width: 570px;
        margin-bottom: 120px;
    }
`;

export const Heading = styled(Heading1)`
    text-align: center;
`;
